import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Controller, useForm } from 'react-hook-form';
import { SimpleTextEditor, CreateChancel } from 'components';
import { postedNoteActions, httpRequestsOnSuccessActions } from 'store';
import { FindLoad, FindSuccessItem, useModal } from 'utils';
import {
    CREATE_POSTED_NOTE_ACTION,
    EDIT_POSTED_NOTE_ACTION,
    POSTED_NOTE_SUBTITLE,
    postedNotePlainLength,
} from './constants';

export const AddPostedNote = ({ clientId, info }) => {
    const dispatch = useDispatch();
    const { close } = useModal();
    const { control, handleSubmit, watch, reset } = useForm({ defaultValues: { note: info?.content || '' } });

    const ACTION_TYPE = info ? EDIT_POSTED_NOTE_ACTION : CREATE_POSTED_NOTE_ACTION;
    const loader = FindLoad(ACTION_TYPE);
    const success = FindSuccessItem(ACTION_TYPE);

    useEffect(() => {
        reset({ note: info?.content || '' });
    }, [info]);

    useEffect(() => {
        if (success) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
            close();
        }
    }, [success]);

    const noteValue = watch('note');
    const length = postedNotePlainLength(noteValue);

    const onSubmit = (data) => {
        const body = { content: data?.note };
        if (info) {
            dispatch(postedNoteActions.editPostedNote(clientId, body));
        } else {
            dispatch(postedNoteActions.createPostedNote(clientId, body));
        }
    };

    return (
        <div className="posted-note-modal">
            <p className="modal-header-title">{info ? 'Edit Posted Note' : 'Add Posted Note'}</p>
            <p className="posted-note-subtitle">{POSTED_NOTE_SUBTITLE}</p>

            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="modal-body-wrapper">
                    {/*<p className="text-editor-title">Note*</p>*/}
                    <Controller
                        control={control}
                        name="note"
                        defaultValue={''}
                        rules={{
                            validate: (value) => postedNotePlainLength(value) > 0 || 'Note is required.',
                        }}
                        render={({ field, fieldState: { error } }) => (
                            <SimpleTextEditor
                                border={error ? '1px solid #FE7070' : '1px solid #0C66E4'}
                                value={field.value}
                                onChange={(val) => field.onChange(val)}
                                placeholder={POSTED_NOTE_SUBTITLE}
                                error={error}
                            />
                        )}
                    />
                </div>

                <CreateChancel
                    type="submit"
                    loader={!!loader.length}
                    create={info ? 'Save Changes' : 'Add'}
                    chancel={'Cancel'}
                    onClose={close}
                    buttonWidth="100%"
                    cancelRight={'24px'}
                />
            </form>
        </div>
    );
};
